const from = [
  'ã',
  'à',
  'á',
  'ä',
  'â',
  'ẽ',
  'è',
  'é',
  'ë',
  'ê',
  'ì',
  'í',
  'ï',
  'î',
  'õ',
  'ò',
  'ó',
  'ö',
  'ô',
  'ù',
  'ú',
  'ü',
  'û',
  'ñ',
  'ç',
]
const to = [
  'a',
  'a',
  'a',
  'a',
  'a',
  'e',
  'e',
  'e',
  'e',
  'e',
  'i',
  'i',
  'i',
  'i',
  'o',
  'o',
  'o',
  'o',
  'o',
  'u',
  'u',
  'u',
  'u',
  'n',
  'c',
]

export default function (value, processors = []) {
  let original = value
  if (processors.length) {
    for (let i = 0; i < processors.length; i++) {
      let processor = processors[i]
      let parts = processor.split(':')
      switch (parts[0]) {
        // Machine readable text
        case 'machine':
          value = value.replace(/^\s+|\s+/g, '_')
          value = value.toLowerCase()
          for (var pos = 0; pos < from.length; pos++) {
            var char = from[pos]
            value = value.replace(new RegExp(char, 'g'), to[pos])
          }
          value = value.replace(/[^a-zA-Z_0-9]/g, '')
          break
        // Url slug
        case 'slug':
          value = value.replace(/^\s+|\s+/g, '-')
          value = value.toLowerCase()
          for (var pos = 0; pos < from.length; pos++) {
            var char = from[pos]
            value = value.replace(new RegExp(char, 'g'), to[pos])
          }
          value = value.replace(/[^a-zA-Z\-0-9]/g, '')
          break
        // Max length for string
        case 'max':
          if (parts[1] !== undefined) {
            value = value.substr(0, parts[1])
          }
          break
        // Add ellipsis if is too long
        case 'maxdots':
          if (parts[1] !== undefined) {
            value = value.substr(0, parts[1])
            if (value !== original) {
              value += '...'
            }
          }
          break
        // Format date
        case 'date':
          let format = parts[1] || 'D.M.YYYY - HH:mm'
          value = moment(value).format(format)
          break
        // Access only numbers
        case 'number':
          value = value.replace(/[^0-9]/g, '')
          break
      }
    }
  }

  return value
}
